export default __webpack_public_path__ + "5801f61c14e031bbe7351be403afe9ea.jpg";